import { global } from '../constants';

export const data = {
	banner: {
		background: global.banner + 'storage-banner.png',
		title: 'Secure Storage Solutions',
		crumb: 'Storage',
	},

	intro: {
		img: global.sgallery + 'storage/secure-storage.jpg',
		tagline: 'PROTECTING WHAT MATTERS MOST',
		heading: 'High-Security Storage for Valuables & Sensitive Goods',
		description:
			'Our secure storage facilities are designed for clients who demand the highest levels of protection, privacy, and care for their valuable assets. Whether it’s precious metals, fine art, confidential documents, or high-value merchandise, we ensure absolute safety through advanced security systems, climate control, and discreet handling.',
	},

	estimation: {
		title: 'BUILT FOR SECURITY & EFFICIENCY',
		subtitle: 'Storage That Works for You',
		description:
			'Our storage network integrates into your supply chain, providing safe, flexible, and discreet asset management in key locations worldwide.',
		solutions: [
			{
				serial: '01',
				icon: global.icons2 + 'surveillance.png',
				title: '24/7 Surveillance',
				description:
					'Advanced CCTV, intrusion detection, and on-site security staff ensure uninterrupted asset protection.',
			},
			{
				serial: '02',
				icon: global.icons2 + 'insurance.png',
				title: 'Full Insurance Coverage',
				description:
					'Comprehensive insurance options safeguard the value of your stored assets.',
			},
			{
				serial: '03',
				icon: global.icons2 + 'liability.png',
				title: 'Complete Liability',
				description:
					'We assume full responsibility for the safety and security of your assets while in our care.',
			},
		],
	},

	blogs: {
		title: 'OUR PROMISE',
		subtitle: 'Security Beyond Expectations',
		description:
			'We go beyond simple storage — our protocols ensure legal compliance, privacy, and peace of mind at every step.',
		blogs: [
			{
				image: global.sgallery + 'storage/facilitiy-management.webp',
				icon: '🔒',
				title: 'Unmatched Facility Standards',
				description:
					'From reinforced walls to biometric entry, our storage facilities are designed to meet the toughest security standards in the industry.',
			},
			{
				image: global.sgallery + 'storage/responsibility.jpg',
				icon: '📦',
				title: 'Care for Every Item',
				description:
					'Each asset is handled, cataloged, and stored with meticulous attention, ensuring its condition remains intact over time.',
			},
		],
	},
};
